import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';
import { Button } from 'components/ui/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faCopy, faFileAlt } from '@fortawesome/pro-solid-svg-icons';

export default function SaveDocumentTemplateModal({
  companyName,
  parentCompanyName,
  saving,
  showCorporateOverrideModal,
  showPageTemplateModal,
  templateName,
  onClose,
  onSave
}) {
  const [propagateToChildren, setPropagateToChildren] = React.useState(false);

  React.useEffect(() => {
    if (showPageTemplateModal) setPropagateToChildren(false);
  }, [showPageTemplateModal]);

  const modalHeader = useMemo(() => {
    if (!showCorporateOverrideModal) return 'Page Default Changes';

    return 'Default Changes';
  }, [showCorporateOverrideModal]);

  const pageTemplateChangeSection = useMemo(() => (
    <React.Fragment>
      <div className="mb-4">
        These page changes can be saved to just this template or to all child templates created from it.
      </div>
      <strong className="fw-semibold">
        Where would you like to save these changes?
      </strong>
      <div className="row">
        <label className="radio radio-inline col-5 border px-5 py-4 m-4">
          <input
            checked={!propagateToChildren}
            name="save-scope"
            type="radio"
            onChange={() => setPropagateToChildren(false)}
          />
          <FontAwesomeIcon className="mx-2" icon={faFileAlt} size="lg"/>
          {templateName}
        </label>
        <label className="radio radio-inline col-5 border px-5 py-4 m-4">
          <input
            checked={propagateToChildren}
            name="save-scope"
            type="radio"
            onChange={() => setPropagateToChildren(true)}
          />
          <FontAwesomeIcon className="mx-2" icon={faCopy} size="lg"/>
          All Child Templates
        </label>
      </div>
    </React.Fragment>
  ), [setPropagateToChildren]);

  const corporateOverrideSection = (
    <div className="mb-4">
      These document defaults are currently inherited from {parentCompanyName}.
      <br />
      Saving will override them for {companyName} only.
    </div>
  );

  return (
    <Modal show={showCorporateOverrideModal || showPageTemplateModal} onHide={onClose}>
      <Modal.Header closeButton>
        {modalHeader}
      </Modal.Header>
      <Modal.Body>
        {showCorporateOverrideModal && corporateOverrideSection}
        {showPageTemplateModal && showCorporateOverrideModal && <hr/>}
        {showPageTemplateModal && pageTemplateChangeSection}
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={saving} label="Cancel" variant="ghost" onClick={onClose} />
        <Button
          disabled={saving}
          label={saving ? 'Saving ...' : 'Save Changes'}
          onClick={() => onSave(propagateToChildren)}
        />
      </Modal.Footer>
    </Modal>
  );
}

SaveDocumentTemplateModal.propTypes = {
  companyName: PropTypes.string.isRequired,
  parentCompanyName: PropTypes.string,
  saving: PropTypes.bool.isRequired,
  showCorporateOverrideModal: PropTypes.bool.isRequired,
  showPageTemplateModal: PropTypes.bool.isRequired,
  templateName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
